import type { SxProps } from "@mui/material"

const buttonContainer: SxProps = {
  gap: { xs: 0, xl: 1 }
}

export default { buttonContainer }
